/**
 * Portal Manta · importarJSONkpisAvancado
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { extKm } from '../../globals.js';
import { detectarFormatoJSON } from './detectarFormatoJSON.jsx';
import { extrairKpisDoFormatoManta } from './extrairKpisDoFormatoManta.jsx';
import { extrairKpisDoFormatoRaso } from './extrairKpisDoFormatoRaso.jsx';
import { extrairKpisDoPortalV26 } from './extrairKpisDoPortalV26.jsx';

function importarJSONkpisAvancado(texto){
  let obj;
  try { obj = JSON.parse(texto); }
  catch(e){ return {ok:false, erro:'JSON inválido: '+e.message}; }

  const formato = detectarFormatoJSON(obj);
  let kpis;
  if (formato === 'manta-completo')        kpis = extrairKpisDoFormatoManta(obj);
  else if (formato === 'raso')             kpis = extrairKpisDoFormatoRaso(obj);
  else if (formato === 'portal-v26')       kpis = extrairKpisDoPortalV26(obj);
  else if (formato === 'manta-lotes-array')return {ok:false, erro:'Formato "lotes_info" detectado · contém múltiplos lotes · escolha um lote específico (lote-X.json)', formato};
  else if (formato === 'invalido')         return {ok:false, erro:'JSON não é objeto/array válido', formato};
  else                                     return {ok:false, erro:'Formato não reconhecido · use lote-X.json (Manta) ou {"extKm":150,...} (raso)', formato};

  return {ok:true, kpis, formato, n_kpis: Object.keys(kpis).filter(k => !k.startsWith('_')).length};
}

export { importarJSONkpisAvancado };
export default importarJSONkpisAvancado;
